// extracted by mini-css-extract-plugin
export default {"container":"LegendItem-module__container___dubxj","colorIcon":"LegendItem-module__colorIcon___WxyB_","square":"LegendItem-module__square___ciKSf"};